import { call, put, takeEvery } from 'redux-saga/effects'
import API from '../../API';
import { toastr } from 'react-redux-toastr'
import axios from 'axios';


async function getApi(data) {
    // const apiUrl = API.baseURL + `/providers/get_elapsed_contacted_projects`;
    const apiUrl = API.baseURL + `/v2/providers/purchased_lead_projects`;
    
    try {
        const response = axios.get(apiUrl, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* buyProjectsData(action) {
    try {
        const response = yield call(getApi, action.data);
        if (response.status == 200 || response.status == 201) {
            // toastr.success('Pegister personal Success', 'You are successfully completed the first step ');
        } else {
            // response.errors.length!=0&&toastr.error('Pegister personal  failed', response.errors[0]);
        }
        // history.push('/');
        yield put({ type: 'GET_ALL_BUY_PROJECTS_DATA_SUCCESS', data: response.data.data });
    } catch (e) {
        yield put({ type: 'GET_ALL_BUY_PROJECTS_DATA_FAILED', message: e.message });
    }
}

function* buyProjectsSaga() {
    yield takeEvery('GET_ALL_BUY_PROJECTS_DATA_REQUESTED', buyProjectsData);
}

export default buyProjectsSaga;